// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__2rC52","time":"styles_time__3apxr"};